import {
  checkDurationEventsInRange,
  checkRateEventsInRange,
  hasRateEvents,
} from '../../utils/parentSupervisionValidation';
import moment from 'moment';
import { TIME_RANGE_FIELDS } from '../../../../../../constants';
import { TIME_RANGE_VALIDATION_RESULTS } from '../../constants/general';

import type { IParentSupervision, TargetProgress, ValueOf } from '../../../../../../utils/types';
import type { TimeRangeField } from '../../../../../../constants';

type TimeRangeValidationResult = ValueOf<typeof TIME_RANGE_VALIDATION_RESULTS>;

interface ValidateTimeRangeUpdateParams {
  key: TimeRangeField;
  value: number;
  targetProgress: TargetProgress[];
  dateStart: IParentSupervision['date_start'];
  expectedDuration: IParentSupervision['expected_duration'];
}

export function validateTimeRangeUpdate({
  key,
  value,
  targetProgress,
  dateStart,
  expectedDuration,
}: ValidateTimeRangeUpdateParams): TimeRangeValidationResult {
  const newStartTime = key === TIME_RANGE_FIELDS.DATE_START ? moment(value) : dateStart;
  const newDuration = key === TIME_RANGE_FIELDS.EXPECTED_DURATION ? value : expectedDuration;

  if (!newStartTime || !newDuration) {
    return TIME_RANGE_VALIDATION_RESULTS.VALID;
  }

  if (checkDurationEventsInRange(targetProgress, newDuration)) {
    return TIME_RANGE_VALIDATION_RESULTS.DURATION_OUT_OF_RANGE;
  }

  if (!hasRateEvents(targetProgress)) {
    return TIME_RANGE_VALIDATION_RESULTS.VALID;
  }

  const outOfRangeCount = checkRateEventsInRange(targetProgress, newStartTime, newDuration);

  if (outOfRangeCount > 0) {
    return TIME_RANGE_VALIDATION_RESULTS.RATE_OUT_OF_RANGE;
  }

  return TIME_RANGE_VALIDATION_RESULTS.VALID;
}
